import { render } from "./AbsPage.vue?vue&type=template&id=05fdfd75&scoped=true&ts=true"
import script from "./AbsPage.vue?vue&type=script&lang=ts"
export * from "./AbsPage.vue?vue&type=script&lang=ts"

import "./AbsPage.vue?vue&type=style&index=0&id=05fdfd75&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fdfd75"]])

export default __exports__